import React, { Component } from 'react';
import '../css/dataTables.css';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    { title: 'N° documento' },
    { title: 'Documento' },
    { title: 'No.Ref.de. cliente' },
    { title: 'Fecha' },
    { title: 'Días de atraso' },
    { title: 'Total' },
    { title: 'Saldo vencido' },
    { title: 'Pago Total' },
];

class InvoicesPaymentModal extends Component {
    constructor(props){
        super(props)
        this.state = {
            checkboxArray: (new Map(): Map<string, boolean>),
        }
    }

    componentDidMount(): void {
        this.closeAction();
    }

    closeItems = async () => {
        $('#invoicesPaymentModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        const state = this;
        $('#invoicesPaymentModal').on('hidden.bs.modal', () => {
            //console.log("Close invoicesPaymentModal");
            cleanData();
            state.setState({
                checkboxArray: (new Map(): Map<string, boolean>),
            })
        });
    };


    selectItems = array => {
        this.setState({
            checkboxArray: array
        })
    };

    selectItemsToArray = () =>{
        const {data, selectItems} = this.props;
        const {checkboxArray} = this.state;

        let items = [];

        for (let [id, value] of checkboxArray.entries()) {
            if (value) {
                items.push(data[id]);
            }
        }

        selectItems(items);
    };

    render() {
        const {data} = this.props;
        if(data.length === 0){
            return <div className="modal fade bd-example-modal-xl bgtransparent"  role="dialog"  id="invoicesPaymentModal"></div>;
        }

        return (
            <div>
                <div className="modal fade bd-example-modal-lg scroll bgtransparent"  role="dialog"  id="invoicesPaymentModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-xl" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Listado de documentos</h4>
                                <button type="button" className="close" onClick={this.closeItems} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div className='table-responsive'>
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"invoicesPaymentModal"} action={this.selectItems} flagInvoices={true} filterByDate={false}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeItems}>Cerrar</button>
                                <button type="button" className="btn botonCorrect" onClick={this.selectItemsToArray}>Agregar</button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.closeAction()}
            </div>
        );
    }
}

export default InvoicesPaymentModal;